// ---------------------------------------------------------------------------
// The simulation room's word. It opens /sim, and while the game is under
// development it is also what lets a newcomer start or join a war: the server
// checks it on both (simGate.ts). Kept for this tab only, and shared between
// the two, so a tester who has given it once is not asked again.
// ---------------------------------------------------------------------------

const KEY = 'tb.sim';

export function rememberedPassword(): string | null {
  try { return sessionStorage.getItem(KEY); } catch { return null; }
}

/** Keep the word for this tab, or forget it when the server has turned it down. */
export function rememberPassword(password: string | null): void {
  try {
    if (password) sessionStorage.setItem(KEY, password);
    else sessionStorage.removeItem(KEY);
  } catch { /* not kept, then: the next press asks again */ }
}
